module.exports = __webpack_public_path__ + "static/media/symfoni_logo_gray.5dfa7df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/symfoni_logo_gray.png
// module id = 1632
// module chunks = 0